'use client'
import { useTranslations } from 'next-intl'
import { Link } from '@/src/navigation'
import { useState } from 'react'
import { useLocale } from 'use-intl'

export default function ClientContactUsComponent() {
  const t = useTranslations('')
  const currentLanguage = useLocale();

  const [formData, setFormData] = useState({
    type: 'Contact us',
    name: '',
    theme: '',
    email: '',
    phone: '',
    message: ''
  })

  const [errors, setErrors] = useState({
    name: '',
    theme: '',
    email: '',
    phone: '',
    message: ''
  })

  const handleChange = (e: any) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value
    })
  }

  const validate = () => {
    let errors: any = {}
    if (!formData.name) errors.name = t('Name is required')
    if (!formData.theme) errors.theme = t('Theme is required')
    if (!formData.email) errors.email = t('Email is required')
    if (!formData.phone) errors.phone = t('Phone is required')
    if (!formData.message) errors.message = t('Message is required')
    return errors
  }

  const handleSubmit = async (e:any) => {
    e.preventDefault()
    const formErrors = validate()
    if (Object.keys(formErrors).length === 0) {
      const apiUrl = process.env.NEXT_PUBLIC_API_GENERAL_URL
      await fetch(apiUrl + '/contact-us/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => response.json())
        .then(data => {
          setFormData({
            type: 'Contact us',
            name: '',
            theme: '',
            email: '',
            phone: '',
            message: ''
          })

          window.location.href = `/${currentLanguage}/thank-you`
        })
        .catch(error => {
          console.error('Error:', error)
        })
    } else {
      setErrors(formErrors)
    }
  }

  return (
    <main>
      <section className='simpleContainer'>
        <div className='container-sections'>
          <h1>{t('Contacts')}</h1>
        </div>

        <div className='simpleContainer gray-background contact-container'>
          <div className='contact-block'>
            <div className='contact-block-left'>
              <p className='contact-form-heading'>
                {t('Fill free to contact us!')}
              </p>
              <form onSubmit={handleSubmit}>
                <input
                  type='hidden'
                  name='_token'
                  value='yQAGypX5Rkdpjsuqza55vepR51h40oAxUODxy2Um'
                />
                <div className='row'>
                  <div className='form-group'>
                    <input
                      className='form-control'
                      name='name'
                      type='text'
                      value={formData.name}
                      onChange={handleChange}
                      id='name'
                      placeholder={t('Name, Surname')}
                    />
                    {errors.name && (
                      <small className='text-danger'>{errors.name}</small>
                    )}
                  </div>

                  <div className='form-group'>
                    <input
                      className='form-control'
                      name='theme'
                      type='text'
                      value={formData.theme}
                      onChange={handleChange}
                      id='theme'
                      placeholder={t('Theme')}
                    />
                    {errors.theme && (
                      <small className='text-danger '>{errors.theme}</small>
                    )}
                  </div>

                  <div className='form-group'>
                    <input
                      className='form-control'
                      name='email'
                      type='text'
                      value={formData.email}
                      onChange={handleChange}
                      id='email'
                      placeholder={t('E-mail')}
                    />
                    {errors.email && (
                      <small className='text-danger'>{errors.email}</small>
                    )}
                  </div>

                  <div className='input-group'>
                    <input
                      className='form-control'
                      name='phone'
                      type='text'
                      value={formData.phone}
                      onChange={handleChange}
                      id='phone'
                      placeholder={t('Tel')}
                    />
                  </div>
                  {errors.phone && (
                    <small className='text-danger'>{errors.phone}</small>
                  )}
                </div>

                <div className='form-group'>
                  <textarea
                    className='form-control'
                    name='message'
                    value={formData.message}
                    onChange={handleChange}
                    placeholder={t('Message')}
                    rows={6}
                  ></textarea>
                  {errors.message && (
                    <small className='text-danger'>{errors.message}</small>
                  )}
                </div>

                <div className='form-group'>
                  <button type='submit' className='btn submit-contact-btn'>
                    {t('Send Request')}
                  </button>
                </div>

                <div className='form-group'>
                  <div className='g-recaptcha' data-sitekey=''></div>
                  <small className='text-danger'></small>
                </div>
              </form>
            </div>
            <div className='contact-block-right'>
              <h6>
                {t(
                  'Contact Yerkir Real Estate Agency operators With the help of our real estate agents you can find or sell/rent apartments, houses and offices in Armenia'
                )}
              </h6>

              <iframe
                src='https://maps.google.com/maps?q=yerkir%20real%20estate&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed'
                width='100%'
                height='400'
                aria-hidden='false'
              ></iframe>

              <p>
                Tel:
                <Link href='tel:+374 10 27 93 93'>+374 10 27 93 93</Link> |
                <Link href='tel:+374 91 27 93 93'>+374 91 27 93 93</Link> |
                <Link href='tel:+374 77 97 00 10'>+374 77 97 00 10</Link>
              </p>

              <div className='row'>
                <p>
                  Viber:{' '}
                  <Link href='viber://contact?number=%2B374+91+27+93+93'>
                    +374 91 27 93 93
                  </Link>
                </p>
                <p>
                  WhatsApp:{' '}
                  <Link href='https://wa.me/%2B374+77+97+00+10'>
                    +374 77 97 00 10
                  </Link>
                </p>
                <p>Fax: +374 10 27 93 93</p>
                <p>
                  E-mail:{' '}
                  <Link href='mailto:info@yerkir-real.com'>info@yerkir-real.com</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}
